import React from 'react';
import { ArrowRight } from 'lucide-react';
import { Button } from '../ui/button';
import { Card, CardContent, CardHeader, CardTitle } from '../ui/card';
import { blogPosts } from '../../enhancedMock';

export const BlogResources = () => (
  <section data-testid="blog-resources-section" className="fade-in-section py-12 md:py-20 px-4 bg-gradient-to-b from-warmBeige/80 to-white/80 backdrop-blur-sm relative z-10">
    <div className="container mx-auto">
      <div className="text-center mb-10 md:mb-16">
        <h2 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold text-darkBrown mb-4">Mental Health Resources</h2>
        <p className="text-sm md:text-xl text-gray-600">Helpful articles and insights</p>
        <div className="w-24 h-1 bg-primaryOrange mx-auto mt-4"></div>
      </div>

      <div className="grid sm:grid-cols-2 md:grid-cols-3 gap-4 md:gap-8">
        {blogPosts.map((post) => (
          <Card key={post.id} className="group border-none shadow-lg hover:shadow-2xl transition-all hover:-translate-y-2 overflow-hidden cursor-pointer bg-white">
            <div className="relative h-36 md:h-48 overflow-hidden">
              <img
                src={post.image}
                alt={post.title}
                className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
              />
              <div className="absolute top-3 left-3 md:top-4 md:left-4">
                <span className="bg-primaryOrange text-white px-2 py-0.5 md:px-3 md:py-1 rounded-full text-xs font-semibold">
                  {post.category}
                </span>
              </div>
            </div>
            <CardHeader className="p-3 md:p-6">
              <CardTitle className="text-darkBrown group-hover:text-primaryOrange transition-colors text-base md:text-lg">{post.title}</CardTitle>
              <div className="flex items-center gap-3 text-xs md:text-sm text-gray-500">
                <span>{post.readTime}</span>
                <span>•</span>
                <span>{post.date}</span>
              </div>
            </CardHeader>
            <CardContent className="p-3 pt-0 md:p-6 md:pt-0">
              <p className="text-xs md:text-sm text-gray-600 mb-3 md:mb-4">{post.excerpt}</p>
              <Button variant="outline" size="sm" className="w-full border-primaryOrange text-primaryOrange hover:bg-primaryOrange hover:text-white text-xs md:text-sm">
                Read More
                <ArrowRight className="ml-2" size={14} />
              </Button>
            </CardContent>
          </Card>
        ))}
      </div>
    </div>
  </section>
);
